import React from 'react'
import { Box, Container } from '@mui/material'
import NextImage from 'next/image'
import NextLink from 'next/link'
import { useTranslation } from 'next-i18next'

import { Routes } from '@/assets/configs'
import VariantImages from '@/assets/VariantImages'
import LinkButton from '@/components/EMT/LinkButton'
import { useIsResponsive } from '@/hooks'

import { usePetsittingMode } from '@/store/usePetsittingMode'

export default function PublicNavigation({ petsitter, from }: { petsitter?: boolean; from?: string }) {
  const tconnection = useTranslation('connection').t
  const [isMobile] = useIsResponsive()
  const { isPetsittingMode } = usePetsittingMode()

  return (
    <Box sx={{ backgroundColor: '#fff' }}>
      <Container>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', minHeight: '80px' }}>
          <NextLink
            href={
              isPetsittingMode
                ? Routes.Connection.WelcomePetsitting
                : 'https://www.empruntemontoutou.com/la-creme-des-pet-sitters/'
            }
            passHref
            className="EmtReactNativeWebViewMarginTop"
          >
            <NextImage
              src={isPetsittingMode || petsitter ? VariantImages.LogoSitterBlackFull : VariantImages.LogoPrimary}
              width={isPetsittingMode || petsitter ? 180 : 143}
              height={isPetsittingMode || petsitter ? 68 : 54}
              alt="logo emprunte mon toutou"
              style={{
                width: isMobile
                  ? isPetsittingMode || petsitter
                    ? '40vw'
                    : '30vw'
                  : isPetsittingMode || petsitter
                  ? '180px'
                  : '143px',
                height: 'auto',
                maxHeight: isPetsittingMode || petsitter ? '68px' : '54px',
              }}
            />
          </NextLink>

          <Box
            sx={{ display: 'flex', gap: isMobile ? '10px' : '20px', alignItems: 'center' }}
            className="EmtReactNativeWebViewMarginTop"
          >
            <LinkButton
              href={Routes.Connection.SignIn + (from ? `?from=${from}` : '')}
              variant="outlined"
              color={isPetsittingMode || petsitter ? 'purple' : 'primary'}
              size={isMobile ? 'small' : 'medium'}
              sx={{ minWidth: isMobile ? '89px' : '200px' }}
            >
              {tconnection('sign-in.title')}
            </LinkButton>

            <LinkButton
              href={Routes.Connection.SignUp.Type + (from ? `?from=${from}` : '')}
              variant="contained"
              color={isPetsittingMode || petsitter ? 'purple' : 'primary'}
              size={isMobile ? 'small' : 'medium'}
              sx={{ minWidth: isMobile ? '89px' : '200px' }}
            >
              {tconnection('sign-up.title')}
            </LinkButton>
          </Box>
        </Box>
      </Container>
    </Box>
  )
}
